import React from "react";
import { playAudio } from "../utils/audioManager";

function StartButton({ onStart }) {
  const handleClick = () => {
    const audio = playAudio("/sound/CulturalTable.MP3", 1);
    onStart(audio);
  };

  return (
    <button
      onClick={handleClick}
      className="bg-black hover:bg-gray-800 text-yellow-400 font-bold py-3 px-6 rounded-full text-xl sm:text-2xl focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-opacity-50 transform transition hover:scale-105"
    >
      Start Game
    </button>
  );
}

export default StartButton;
